import React, { useState } from 'react';
import Validator from 'validatorjs';
import { Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';

const ImpuestosTrasladadosForm = (props) => {
  const [, setValidator] = useState({
    isValid: false,
    validator: new Validator(),
  });

  const getRules = (data) => {
    return {
      Base: ['required', 'regex:/^[0-9]{1,18}(.[0-9]{1,6})?$/'],
      Impuesto: ['required'],
      TipoFactor: ['required'],
      TasaCuota: ['required'],
      Importe: ['required', 'regex:/^[0-9]{1,18}(.[0-9]{1,6})?$/'],
    };
  };

  const handleOnChange = (event) => {
    const data = {
      ...props.data,
      ...event,
    };

    const validator = validate(data);

    props.onFormDataChange(
      {
        ImpuestosTrasladadosdelServicio: data,
      },
      {
        name: 'isValidImpuestosTrasladadosdelServicio',
        isValid: validator.passes(),
      }
    );
  };

  const validate = (data) => {
    const validator = new Validator(data, getRules(data));

    validator.check();

    setValidator({
      validator,
      isValid: validator.passes(),
    });

    return validator;
  };

  const { data = {} } = props;
  const rules = getRules(data);

  return (
    <Row>
      <Col
        sm
        md={4}
      >
        <FormControl
          type="number"
          label="Base"
          name="Base"
          placeholder=""
          help=""
          rules={rules.Base}
          value={data.Base}
          onChange={handleOnChange}
        />
      </Col>

      <Col
        sm
        md={4}
      >
        <FormControl
          type="select"
          label="Impuesto"
          name="Impuesto"
          placeholder=""
          help=""
          minLength="21"
          maxLength="21"
          rules={rules.Impuesto}
          value={data.Impuesto}
          options={Impuesto}
          onChange={handleOnChange}
        />
      </Col>

      <Col
        sm
        md={4}
      >
        <FormControl
          type="select"
          label="Tipo Factor"
          name="TipoFactor"
          placeholder=""
          help=""
          minLength="21"
          maxLength="21"
          rules={rules.TipoFactor}
          value={data.TipoFactor}
          options={TipoFactor}
          onChange={handleOnChange}
        />
      </Col>

      <Col
        sm
        md={4}
      >
        <FormControl
          type="number"
          label="Tasa"
          name="TasaCuota"
          placeholder=""
          help=""
          rules={rules.TasaCuota}
          value={data.TasaCuota}
          onChange={handleOnChange}
        />
      </Col>

      <Col
        sm
        md={4}
      >
        <FormControl
          type="number"
          label="Importe"
          name="Importe"
          placeholder=""
          help=""
          rules={rules.Importe}
          value={data.Importe}
          onChange={handleOnChange}
        />
      </Col>
    </Row>
  );
};

const Impuesto = [
  {
    label: 'Selecciona',
    value: '',
  },
  {
    label: 'ISR',
    value: '01',
  },
  {
    label: 'IVA',
    value: '02',
  },
  {
    label: 'IEPS',
    value: '03',
  },
];

const TipoFactor = [
  {
    label: 'Selecciona',
    value: '',
  },
  {
    label: 'Tasa',
    value: 'Tasa',
  },
];

export default ImpuestosTrasladadosForm;
